// extracted by mini-css-extract-plugin
module.exports = {"container":"BookSelect_container__1ewAg","text":"BookSelect_text__ZNydh","placeholder":"BookSelect_placeholder__5kZDP","md":"BookSelect_md__auOFO","sd":"BookSelect_sd__2x3NS"};